<script setup lang="ts">
import Markdown from '@satch-ui/components/markdown/Markdown.vue'

defineProps<{
  error?: string
  helper?: string
  padding?: null | 'base'
}>()
</script>

<template>
  <div
    class="text-2xs md:text-hint mb-1.5 min-h-[1.125rem] w-full md:mb-2.5"
    :class="{
      'text-gray-medium': !error && helper,
      'text-red': error,
      'px-4': padding !== null,
    }"
  >
    <Markdown
      v-if="error || helper"
      :variant="null"
      :content="String(error || helper)"
    />
  </div>
</template>
